import React from 'react';
import { cn } from '@/helpers/utils';
import { modalTypes } from '../../common/modals/constants';
import MobilePolicyButton from '../../common/MobilePolicyButton';
import LoungeDetailsCardPickerMessage from './LoungeDetailsCardPickerMessage';
import { policyButtonIds } from './constants';
import type { LoungeDetailsSidebarProps } from './types';

const MobileLoungeDetailsSidebar = ({
  className,
  sidebarData,
}: LoungeDetailsSidebarProps) => {
  const {
    accessPolicyHeading,
    cardImageSrc,
    guestPolicyHeading,
    hasAccessPolicy,
    hasGuestPolicy,
    inlineCardMessage,
    product,
  } = sidebarData;

  return (
    <div className={cn(className, 'tw-border-b tw-border-gray-300 tw-pb-3')}>
      <div className="tw-flex tw-items-center tw-py-3">
        <img
          src={cardImageSrc}
          alt={product || 'Card'}
          className="tw-mr-3 tw-h-7 tw-w-11 tw-shrink-0"
        />
        <LoungeDetailsCardPickerMessage
          text={inlineCardMessage}
          className="tw-min-w-0 tw-flex-1 tw-font-dls tw-text-base tw-font-normal tw-text-gray-800"
        />
      </div>
      {(hasAccessPolicy || hasGuestPolicy) && (
        <div className="tw-flex tw-gap-2 tw-pb-3">
          {hasAccessPolicy && (
            <MobilePolicyButton
              id={policyButtonIds.mobile.access}
              heading={accessPolicyHeading}
              modalType={modalTypes.ACCESS_POLICY_MODAL}
            />
          )}
          {hasGuestPolicy && (
            <MobilePolicyButton
              id={policyButtonIds.mobile.guest}
              heading={guestPolicyHeading}
              modalType={modalTypes.GUEST_POLICY_MODAL}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default MobileLoungeDetailsSidebar;
